import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CartAdapter } from '@spartacus/cart/base/core';
import { Cart, CART_NORMALIZER } from '@spartacus/cart/base/root';
import {
  ConverterService,
  InterceptorUtil,
  Occ,
  OCC_CART_ID_CURRENT,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { map, pluck, switchMap } from 'rxjs/operators';

import { KN_BR_CUSTOMER_CURRENT } from '../../constants/api.endpoints.constant';
import { KnBrCustomerContextService } from '../store/kn-br-customer-context/kn-br-customer-context.service';

@Injectable()
export class KnBrOccCartAdapter implements CartAdapter {
  customerId: string;
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converterService: ConverterService,
    private customerContextService: KnBrCustomerContextService
  ) {
    this.customerContextService.get$.subscribe((response) => {
      this.customerId = response && response.customerNumber ? response.customerNumber : null;
    });
  }

  public loadAll(userId: string): Observable<Cart[]> {
    const customerId = this.customerId ? this.customerId : KN_BR_CUSTOMER_CURRENT;
    return this.http

      .get<Occ.CartList>(this.occEndpointsService.buildUrl('carts', { urlParams: { customerId } }))
      .pipe(pluck('carts'), this.converterService.pipeableMany(CART_NORMALIZER));
  }

  // public load(userId: string, cartId: string): Observable<Cart> {
  //   if (cartId === OCC_CART_ID_CURRENT) {
  //     return this.loadAll(userId).pipe(
  //       map((carts) => {
  //         if (carts) {
  //           const activeCart = carts.find((cart) => {
  //             return cart.saveTime === undefined;
  //           });
  //           return activeCart;
  //         } else {
  //           return null;
  //         }
  //       })
  //     );
  //   } else {
  //     if (window.location.href.indexOf('/login') > -1) {
  //       localStorage.removeItem('spartacus⚿carlisle-customer⚿cart');
  //       return of({});
  //     }

  //     const customerId = this.customerId ? this.customerId : KN_BR_CUSTOMER_CURRENT;
  //     return this.http
  //       .get<Occ.Cart>(this.occEndpointsService.buildUrl('cart', { urlParams: { customerId, cartId } }))
  //       .pipe(this.converterService.pipeable(CART_NORMALIZER));
  //   }
  // }
  public load(userId: string, cartId: string): Observable<Cart | null> {
    // prevent API call on login page
    // if (window.location.href.includes('/login')) {
    //   localStorage.removeItem('spartacus⚿carlisle-customer⚿cart');
    //   return of(null);
    // }

    return this.loadAll(userId).pipe(
      switchMap((carts) => {
        if (!carts?.length) {
          console.log('No carts available');
          return of(null);
        }

        if (cartId === OCC_CART_ID_CURRENT) {
          const activeCart = carts.find((cart) => !cart.saveTime);
          return of(activeCart ?? null);
        }

        const hasCart = carts.some((cart) => cart.code === cartId);
        if (!hasCart) {
          console.log(`Cart ${cartId} not found in cart list`);
          return of(null);
        }

        const customerId = this.customerId || KN_BR_CUSTOMER_CURRENT;
        return this.http
          .get<Occ.Cart>(
            this.occEndpointsService.buildUrl('cart', {
              urlParams: { customerId, cartId },
            })
          )
          .pipe(this.converterService.pipeable(CART_NORMALIZER));
      })
    );
  }

  create(userId: string, oldCartId?: string, toMergeCartGuid?: string): Observable<Cart> {
    const toAdd = JSON.stringify({});

    let params: { toMergeCartGuid?: string; oldCartId?: string } = {};

    if (oldCartId) {
      params = { oldCartId };
    }
    if (toMergeCartGuid) {
      params.toMergeCartGuid = toMergeCartGuid;
    }

    return this.http

      .post<Occ.Cart>(
        this.occEndpointsService.buildUrl('createCart', {
          urlParams: { customerId: this.customerId },
          queryParams: { params },
        }),
        toAdd
      )
      .pipe(this.converterService.pipeable(CART_NORMALIZER));
  }

  delete(userId: string, cartId: string): Observable<{}> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }
    return this.http.delete<{}>(
      this.occEndpointsService.buildUrl('deleteCart', { urlParams: { customerId: this.customerId, cartId } }),
      { headers }
    );
  }

  addEmail(userId: string, cartId: string, email: string): Observable<{}> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    const httpParams: HttpParams = new HttpParams().set('email', email);

    const url = this.occEndpointsService.buildUrl('addEmail', {
      urlParams: {
        customerId: this.customerId,
        cartId,
      },
    });

    return this.http.put(url, httpParams, { headers });
  }
  save(userId: string, cartId: string, saveCartName?: string, saveCartDescription?: string): Observable<Cart> {
    return;
  }
}
